import {createActions} from 'redux-actions';

export const {
    setSelectedSize,
} = createActions({
    SET_SELECTED_SIZE: size => size,
});